import { render, staticRenderFns } from "./AddressSuggest.vue?vue&type=template&id=47ee6720&"
import script from "./AddressSuggest.vue?vue&type=script&lang=js&"
export * from "./AddressSuggest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47ee6720')) {
      api.createRecord('47ee6720', component.options)
    } else {
      api.reload('47ee6720', component.options)
    }
    module.hot.accept("./AddressSuggest.vue?vue&type=template&id=47ee6720&", function () {
      api.rerender('47ee6720', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AddressSuggest.vue"
export default component.exports